'use strict'
import axios from 'axios'
import { triggerChange, debounce, isEmpty, getUrlString } from '~/misc/Utils'
import { on } from 'delegated-events'

const serialize = require('form-serialize')

export default class CollectionFilters {
    constructor() {
        this.getDom()
        this.onLoad()
        this.bindEvents()
    }

    getDom() {
        this.body = document.body
        this.filterForm = document.getElementById('collection-filters-form')
        this.viewFilters = document.querySelector('.view-filters')
        this.filterSidebar = document.querySelector('.filter-sidebar')
        this.closeFilterSidebar = document.querySelector('.filter-sidebar--close')

        /* Inputs */
        this.minPrice = document.querySelector('.min-price')
        this.maxPrice = document.querySelector('.max-price')
        this.sort = document.querySelector('.collection-sort-input')
        this.checkboxes = document.querySelectorAll('.filter-accordion input[type="checkbox"]')
        this.radioButtons = document.querySelectorAll('.filter-accordion input[type="radio"]')
        this.applyButton = document.getElementById('collection-filter-submit')
        this.clearAll = document.querySelector('.collection-filter-clear')
        this.selectInput = document.querySelector('.select-input')
        this.currentSelectPrice = null
        this.currentOffer = null

        /* Results */
        this.productGrid = document.querySelector('.products-grid')
        this.result = document.querySelector('.product-collection-result-count')
        this.loadMoreContainer = document.querySelector('.load-more-container')
        this.currentUrl = window.location.pathname
    }

    onLoad() {}

    bindEvents() {
        this.viewFilters.addEventListener('click', this.handleViewFiltersClick.bind(this))
        this.closeFilterSidebar.addEventListener('click', this.handleViewFiltersClick.bind(this))

        this.clearAll.addEventListener('click', this.clearFilters.bind(this))
        this.filterForm.addEventListener('submit', this.submitForm.bind(this))
        this.selectInput.addEventListener('change', this.handleSelectInput.bind(this))

        on('click', '#load-more', this.handleLoadMore.bind(this))

        this.checkboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', this.handleCheckbox.bind(this))
        })

        this.radioButtons.forEach((radio, index) => {
            // radio.addEventListener('change', this.handleRadioButtons.bind(this, index))
            radio.addEventListener('click', this.handleRadioButtons.bind(this, index))
        })
    }

    handleViewFiltersClick(event) {
        this.body.classList.toggle('overflow-hidden')
        this.filterSidebar.classList.toggle('is-visible')
    }

    handleCheckbox(event) {
        this.applyButton.click()
    }

    handleSelectInput(event) {
        this.sort.value = event.target.value
        this.applyButton.click()
    }

    handleRadioButtons(index, event) {
        if (event.target.name === 'price') {
            if (this.currentSelectPrice === index) {
                event.target.checked = false
                this.currentSelectPrice = null
                this.minPrice.value = ''
                this.maxPrice.value = ''
                this.applyButton.click()
                return
            }

            const price = event.target.value.split('-')
            this.minPrice.value = parseInt(price[0])
            this.maxPrice.value = parseInt(price[1])
            this.currentSelectPrice = index
        }

        if (event.target.name === 'offer-range') {
            const collectionUrl = event.target.dataset.collectionUrl

            if (this.currentOffer === index) {
                event.target.checked = false
                this.currentOffer = null
                this.filterForm.action = '/collection/all'

                if (window.history.replaceState) {
                    window.history.pushState({}, '', this.currentUrl)
                }

                this.applyButton.click()
                return
            }

            if (collectionUrl) {
                this.filterForm.action = collectionUrl
                this.currentOffer = index

                // update window.location.pathname in the url
                if (window.history.replaceState) {
                    window.history.pushState({}, '', collectionUrl)
                }
            }
        }

        debounce(() => {
            this.applyButton.click()
        }, 500)()
    }

    submitForm(event) {
        event.preventDefault()
        this.updateUrl(event)
        const url = window.location.pathname + window.location.search

        axios
            .get(url)
            .then((response) => {
                const htmlElement = document.createElement('div')
                htmlElement.innerHTML = response.data
                const content = htmlElement.querySelector('.products-grid').innerHTML
                const total = htmlElement.querySelector('.product-collection-result-count').innerHTML
                const pagination = htmlElement.querySelector('.load-more-container').innerHTML

                this.render(content, pagination, total)
            })
            .catch((error) => {
                this.render('', '', '')
            })
    }

    handleLoadMore(event) {
        event.preventDefault()
        const url = event.target.dataset.nextUrl
        event.target.classList.add('is-loading')

        axios
            .get(url)
            .then((response) => {
                const htmlElement = document.createElement('div')
                htmlElement.innerHTML = response.data
                const content = htmlElement.querySelector('.products-grid').innerHTML
                const total = htmlElement.querySelector('.product-collection-result-count').innerHTML
                const pagination = htmlElement.querySelector('.load-more-container').innerHTML

                this.render(content, pagination, total, true)
            })
            .finally(() => {
                event.target.classList.remove('is-loading')
            })
    }

    clearFilters(event) {
        event.preventDefault()
        const inputs = [...this.checkboxes, ...this.radioButtons]

        inputs.forEach((input) => {
            input.checked = false
            triggerChange(input)
        })

        this.minPrice.value = ''
        this.maxPrice.value = ''

        debounce(() => {
            this.applyButton.click()
        }, 500)()
    }

    updateUrl(event) {
        const baseUrl = window.location.href.split('?')[0]

        if (window.history.replaceState) {
            const obj = serialize(event.target, { hash: true })
            delete obj.price

            const filters = getUrlString(obj)

            if (isEmpty(filters)) {
                window.history.pushState({}, '', baseUrl)
            } else {
                window.history.pushState({}, '', baseUrl + '?' + filters)
            }
        }
    }

    render(content, pagination, total, append = false) {
        if (!append) {
            this.productGrid.innerHTML = content.trim()
        } else {
            this.productGrid.insertAdjacentHTML('beforeend', content)
        }

        this.result.innerHTML = total.trim()
        this.loadMoreContainer.innerHTML = pagination.trim()
    }
}
